$(document).ready(function(){     
var page_index = 1;
var seo_contents = '';
var faqcontents = '';

var url_main =  window.location.href;
var queryString = window.location.search;
 

$(document).on('click', 'a', function() {
  var url = $(this).attr('href');
  if (url.includes('?page=')) {
    var current_index = url.split('?page=')[1]; 
    page_index = current_index;
    if(page_index > 1){
     $('.seo_conetnts_for_collection_page').remove();
      $('.accordion_with_metafields_collection_page').remove();
     }else{
        getdata();
    }
  } 
});

   $(document).on('click', 'button', function() {
    if($(this).hasClass('prev')){
      page_index = page_index - 1;
      if(page_index > 1 ){
       $('.seo_conetnts_for_collection_page').remove();
      $('.accordion_with_metafields_collection_page').remove();
      }else{
         getdata();
      }
    }else if($(this).hasClass('next')){
      page_index = page_index + 1;
      if(page_index > 1){
        $('.seo_conetnts_for_collection_page').remove();
        $('.accordion_with_metafields_collection_page').remove();
    }else{
      getdata();  
    }
    }
   })
});


 function getdata(){
   var shop_url = window.location.href;
   if(shop_url)shop_url=shop_url.split('?')[0];
  $.ajax({
  url: `${shop_url}`,
  type: "GET",
  success: function (data) {
  // var sectionHTML = $(data).find('.new__featured_collection').html();
  var seo_contents = $(data).find('.seo_conetnts_for_collection_page');
  var faqcontents = $(data).find('.accordion_with_metafields_collection_page');
  if (seo_contents) {
   $('#MainContent').append(seo_contents); 
  }
  if (faqcontents) {
   $('#MainContent').append(faqcontents); 
  }
  },
  error: function () {
  console.error("Failed to load section data.");
  }
  });
 }